class BundlerBuilder extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.bundlePropertyKey =
      this.dataset.bundlePropertyKey || "_part_of_bundle";
    this.bundlePropertyValue =
      this.dataset.bundlePropertyValue || "Build your own bundle";
    // this.BUNDLE_VARIANT_ID = this.getAttribute("data-bundle-variant-id");
    this.navigation = this.querySelector(".bundler-builder--navigation");

    this.addToCartBtn = this.navigation.querySelector(
      "button[data-add-bundle-to-cart]"
    );

    this.productsGrid = this.querySelector(".bundler-builder--grid");

    this.productsGrid.addEventListener(
      "input",
      this.productsGridInputEventHandler.bind(this)
    );

    this.navigation.addEventListener(
      "click",
      this.navigationEventHandler.bind(this)
    );
  }

  disconnectedCallback() {
    this.productsGrid.removeEventListener(
      "input",
      this.productsGridInputEventHandler.bind(this)
    );
    this.navigation.removeEventListener(
      "click",
      this.navigationEventHandler.bind(this)
    );
  }

  productsGridInputEventHandler(event) {
    event.preventDefault();
    const input = event.target.closest(`input[type="checkbox"]`);
    if (!input) return;

    const label = input.nextElementSibling;
    const productImg = label.querySelector("img");
    const productImgClone = productImg.cloneNode(true);

    if (this.checkBundleSize() > 5) {
      input.checked = false;
      return;
    }

    if (input.checked) {
      this.setProductImageInNavItem(productImgClone, input.value);
    }
    input.checked = false;
    this.setDisabledAddToCartBtn();
  }

  navigationEventHandler(event) {
    const navItem = event.target.closest(".bundler-builder--nav-item");
    const button = event.target.closest("[data-add-bundle-to-cart]");

    if (navItem) {
      const { navItemIndex } = navItem.dataset;
      this.removeProductFromNavigation(navItemIndex);
      // this.removeCheckedProduct(navItemProdId);
      this.setDisabledAddToCartBtn();
    }

    if (button) {
      this.addToCart();
    }
  }

  setProductImageInNavItem(imgElement, productId) {
    const emptyNavItem = this.getEmptyNavItem();
    if (!emptyNavItem) return;

    emptyNavItem.appendChild(imgElement);
    emptyNavItem.dataset.navItemProdId = productId;
    emptyNavItem.dataset.navItemHasContent = true;
  }

  //add to cart individual products
  async addToCart() {
    const productIds = this.getProductsIds();

    if (productIds.length < 3 || productIds.length > 5) {
      console.error("The bundle must contain 3 to 5 items.");
      return;
    }

    this.setLoadingStateAddToCartBtn(true);

    try {
      const bundleProperties = this.getBundleProperties();
      const items = productIds.map((id) => ({
        id: id,
        quantity: 1,
        ...(bundleProperties ? { properties: bundleProperties } : {}),
      }));

      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items }),
      });

      if (!response.ok) throw new Error("Error adding products to cart");

      console.log("Productos agregados individualmente al carrito 🎉");
    } catch (error) {
      console.error(`Bundler Build | addToCart | ${error}`);
    } finally {
      this.setLoadingStateAddToCartBtn(false);
      this.resetElements();
      this.setDisabledAddToCartBtn();
      openCartDrawer(true);
    }
  }
  //end add to cart individual products

  getEmptyNavItem() {
    return this.navigation.querySelector(
      `.bundler-builder--nav-item[data-nav-item-has-content="false"]`
    );
  }

  removeProductFromNavigation(navItemIndex) {
    const navItem = this.navigation.querySelector(
      `[data-nav-item-index="${navItemIndex}"]`
    );

    if (!navItem) return;

    navItem.dataset.navItemHasContent = false;
    navItem.dataset.navItemProdId = "";
    navItem.innerHTML = "";
  }

  // removeCheckedProduct(productId) {
  //   this.productsGrid.querySelector(
  //     `input[type="checkbox"][value="${productId}"]`
  //   ).checked = false;
  // }

  setDisabledAddToCartBtn() {
    const checkedProducts = this.checkBundleSize();
    console.log(checkedProducts);
    this.addToCartBtn.disabled = checkedProducts < 3;
    this.addToCartBtn.innerHTML = `${
      checkedProducts < 3 ? "ADD MORE" : "ADD TO CART"
    }`;
  }

  setLoadingStateAddToCartBtn(flag) {
    this.addToCartBtn.disabled = flag;
  }

  checkBundleSize() {
    const navItems = this.navigation.querySelectorAll(
      `[data-nav-item-has-content="true"]`
    );

    return navItems ? navItems.length : 0;
  }

  getProductsIds() {
    return Array.from(
      this.navigation.querySelectorAll(
        `.bundler-builder--nav-item[data-nav-item-has-content="true"]`
      )
    )
      .map((el) => el.dataset.navItemProdId)
      .filter(Boolean);
  }

  getBundleProperties() {
    if (!this.bundlePropertyKey) return null;

    return {
      [this.bundlePropertyKey]: this.bundlePropertyValue || "",
    };
  }

  getBundleDetails() {
    // Build a human-readable descriptor for each selection to fuel the Rebuy cart template
    return Array.from(
      this.navigation.querySelectorAll(
        `.bundler-builder--nav-item[data-nav-item-has-content="true"]`
      )
    )
      .map((navItem) => {
        const productId = navItem.dataset.navItemProdId;
        if (!productId) return "";

        const checkbox = this.productsGrid.querySelector(
          `input[type="checkbox"][value="${productId}"]`
        );
        if (!checkbox) return "";

        const label = checkbox.nextElementSibling;
        if (!label) return "";

        const title = label
          .querySelector(".bundler-product-title")
          ?.textContent.trim();

        const detailParts = [];
        if (title) detailParts.push(title);

        return detailParts.join(" | ");
      })
      .filter(Boolean);
  }

  resetElements() {
    this.navigation
      .querySelectorAll(".bundler-builder--nav-item")
      .forEach((el) => {
        el.dataset.navItemProdId = "";
        el.dataset.navItemHasContent = false;
        el.innerHTML = "";
      });

    this.productsGrid
      .querySelectorAll(".bundler-builder--grid-item input[type='checkbox']")
      .forEach((el) => {
        el.checked = false;
      });
  }
}
customElements.define("bundler-builder", BundlerBuilder);
